import React, { useState, useEffect } from "react";
import { Col, Row, Image, Spinner } from "react-bootstrap";
import warning from "../../assets/icons/warning.png";
import { WizardSteps } from "./WizardSteps";
import { Nextsteps } from "./NextStep";
import { debounce } from "lodash";

export const Eight = (props) => {
  const validate = () => {
    if (window.confirm("Are you sure you want to go back?")) {
      // eslint-disable-line
      props.previousStep();
    }
  };

  const [state, updateState] = useState({
    accountHolderName: "",
    bankAccountShortCode: "",
    accountNumber: "",
    reAccountNumber: "",
    matchMessage: "",
    bankAddress: {
      address1: "",
      address2: "",
      apartment: "",
      city: "",
      country: "",
      postCode: "",
    },
    allowContributions: false,
    postCodeArray: [],
    searchmode: false,
    postcodeLoader: false,
  });

  useEffect(() => {
    let {
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
      bankAddress,
    } = state;
    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    accountHolderName = TutorInfoObj?.step8?.accountHolderName
      ? TutorInfoObj?.step8?.accountHolderName
      : "";
    bankAccountShortCode = TutorInfoObj?.step8?.bankAccountShortCode
      ? TutorInfoObj?.step8?.bankAccountShortCode
      : "";
    accountNumber = TutorInfoObj?.step8?.accountNumber
      ? TutorInfoObj?.step8?.accountNumber
      : "";
    bankAddress = TutorInfoObj?.step8?.bankAddress
      ? TutorInfoObj?.step8?.bankAddress
      : {};

    updateState((state) => ({
      ...state,
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
      reAccountNumber: accountNumber,
      bankAddress,
    }));
    if (props.funcStatus === "loading..." && props.currentStep === 8) {
      submitStep8Info(true);
    }
  }, [props]);

  // step8: {
  //   accountHolderName: "Tawheed Raheem",
  //   bankAccountShortCode: "XDFK",
  //   accountNumber: "1234567",
  // },

  const submitStep8Info = (isCallApi) => {
    const {
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
      bankAddress, //bankAddress
      allowContributions,
    } = state;
    let bankAddressRaw = `${bankAddress.address1}, ${bankAddress.city} ${bankAddress.country} ${bankAddress.postCode}`;
    const { TutorInfoObj } = props;

    let step8 = {
      accountHolderName,
      bankAccountShortCode,
      accountNumber,
      bankAddress,
      bankAddressRaw,
      allowContributions,
    };
    TutorInfoObj.step8 = step8;
    props.AddTutorInfo(TutorInfoObj);
    return isCallApi ? props.AddTutorInfoStepBeforeCallApi("done") : null;
  };

  const getPostCode = debounce((text) => {
    updateState({
      ...state,
      postcodeLoader: true,
    });
    let isInputFieldEmptyRE = /^\s*$/;
    if (!isInputFieldEmptyRE.test(text)) {
      fetch(`https://api.postcodes.io/postcodes/${text}/autocomplete`)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.status === 200) {
            updateState({
              ...state,
              postCodeArray: response.result,
              searchmode: true,
              postcodeLoader: false,
            });
          }
        })
        .catch((error) => {
          updateState({
            ...state,
            postcodeLoader: false,
          });
        });
    } else {
      updateState({
        ...state,
        searchmode: false,
        postcodeLoader: false,
        postCodeArray: [],
      });
    }
  }, 200);

  const matchReAccount = (e) => {
    const { accountNumber } = state;
    if (e.target.value) {
      updateState({
        ...state,
        reAccountNumber: e.target.value,
        matchMessage:
          accountNumber === e.target.value
            ? ""
            : "Account number does not match",
      });
    } else {
      updateState({
        ...state,
        reAccountNumber: "",
        matchMessage: "",
      });
    }
  };
  const {
    accountHolderName,
    bankAccountShortCode,
    accountNumber,
    reAccountNumber,
    matchMessage,
    bankAddress,
    postCodeArray,
    searchmode,
    postcodeLoader,
    allowContributions,
  } = state;
  const { iscompletedForm, validationError } = props;

  let warningError = (
    <img
      src={warning}
      alt="warning"
      width="14px"
      height="14px"
      style={{ marginRight: "6px" }}
    />
  );

  return (
    <Row className="m-0">
      <WizardSteps step={8} {...props} previousStep={validate} />
      <Col lg={12} md={12} sm={12} xs={12}>
        <div className="container">
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="subject-mode Account-detail"
            >
              <p className="step-title">
                Add bank account information for payments to you
              </p>
              <p className="step-subtitle">
                This needs to be a UK Bank account with a UK billing address.
                You can change these details at any point, by entering your new
                details in the fields below.
              </p>

              <p className="label" style={{ marginTop: "35px" }}>
                Account name
              </p>
              <input
                type="text"
                value={accountHolderName}
                placeholder="Account holder name"
                disabled={!iscompletedForm ? false : true}
                className={
                  !accountHolderName
                    ? validationError?.data?.accountHolderName
                      ? "form-control errorInput"
                      : "form-control"
                    : "form-control"
                }
                onChange={(e) =>
                  updateState({
                    ...state,
                    accountHolderName: e.target.value,
                  })
                }
              />
              <div className="error">
                {!accountHolderName
                  ? validationError?.data?.accountHolderName
                    ? warningError
                    : ""
                  : ""}
                {!accountHolderName
                  ? validationError?.data?.accountHolderName
                    ? "Account name required"
                    : ""
                  : ""}
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <p className="label">Bank account sort code</p>
                  <input
                    type="number"
                    placeholder="e.g. 123456"
                    value={bankAccountShortCode}
                    disabled={!iscompletedForm ? false : true}
                    className={
                      !bankAccountShortCode
                        ? validationError?.data?.bankAccountShortCode
                          ? "form-control errorInput"
                          : "form-control"
                        : "form-control"
                    }
                    onChange={(e) =>
                      updateState({
                        ...state,
                        bankAccountShortCode: e.target.value,
                      })
                    }
                  />
                  <div className="error">
                    {!bankAccountShortCode
                      ? validationError?.data?.bankAccountShortCode
                        ? warningError
                        : ""
                      : ""}
                    {!bankAccountShortCode
                      ? validationError?.data?.bankAccountShortCode
                        ? "Account sort code required"
                        : ""
                      : ""}
                  </div>
                </div>
                <div className="col-lg-6">
                  <p className="label">Account number</p>
                  <input
                    type="number"
                    value={accountNumber}
                    placeholder="E.g. 12345678"
                    disabled={!iscompletedForm ? false : true}
                    className={
                      !accountNumber
                        ? validationError?.data?.accountNumber
                          ? "form-control errorInput"
                          : "form-control"
                        : "form-control"
                    }
                    onChange={(e) =>
                      updateState({
                        ...state,
                        accountNumber: e.target.value,
                        matchMessage:
                          e.target.value === reAccountNumber
                            ? ""
                            : "Account number does not match",
                      })
                    }
                  />
                  <div className="error">
                    {!accountNumber
                      ? validationError?.data?.accountNumber
                        ? warningError
                        : ""
                      : ""}
                    {!accountNumber
                      ? validationError?.data?.accountNumber
                        ? "Account number required"
                        : ""
                      : ""}
                  </div>
                </div>
              </div>

              <p className="label">Confirm account number</p>
              <input
                type="number"
                value={reAccountNumber}
                onChange={(e) => matchReAccount(e)}
                placeholder="Re-type account number"
                disabled={!iscompletedForm ? false : true}
                className={
                  !reAccountNumber
                    ? validationError?.data
                      ? "form-control errorInput"
                      : "form-control"
                    : "form-control"
                }
                style={{
                  color: !(matchMessage === "") ? "#fa4a4a" : "",
                  borderColor: !(matchMessage === "") ? "#fa4a4a" : "",
                  backgroundColor: !(matchMessage === "") ? "#fff1f1" : "",
                }}
              />
              <div className="error">
                {!reAccountNumber
                  ? validationError?.data
                    ? warningError
                    : ""
                  : ""}
                {!reAccountNumber
                  ? validationError?.data
                    ? "Confirm your account number"
                    : ""
                  : ""}
                {!(matchMessage === "") ? warningError : ""}
                {!(matchMessage === "") ? matchMessage : ""}
              </div>

              <div style={{ marginBottom: "40px" }} />

              <p className="step-title">Billing address</p>
              <p className="step-subtitle">
                Add the address that bank or financial institution has for this
                account
              </p>

              <p className="label">Address line 1</p>
              <input
                type="text"
                placeholder="Address line 1"
                name="address1"
                disabled={!iscompletedForm ? false : true}
                value={bankAddress?.address1 ? bankAddress?.address1 : ""}
                className={
                  !bankAddress?.address1
                    ? validationError?.data
                      ? "form-control errorInput"
                      : "form-control"
                    : "form-control"
                }
                onChange={(e) => {
                  bankAddress[e.target.name] = e.target.value;
                  updateState({
                    ...state,
                    bankAddress,
                  });
                }}
              />
              <div className="error">
                {!bankAddress?.address1
                  ? validationError?.data
                    ? warningError
                    : ""
                  : ""}
                {!bankAddress?.address1
                  ? validationError?.data
                    ? "Please enter a maximum of 35 characters."
                    : ""
                  : ""}
              </div>

              <p className="label">
                Apartment, Suite, Building Access Code (Optional)
              </p>
              <input
                type="text"
                name="apartment"
                className="form-control"
                disabled={!iscompletedForm ? false : true}
                value={bankAddress?.apartment ? bankAddress?.apartment : ""}
                placeholder="Apartment, Suite, Building Access Code (Optional)"
                onChange={(e) => {
                  bankAddress[e.target.name] = e.target.value;
                  updateState({
                    ...state,
                    bankAddress,
                  });
                }}
              />

              <p className="label">Address line 2</p>
              <input
                type="text"
                name="address2"
                className="form-control"
                placeholder="Address line 2"
                disabled={!iscompletedForm ? false : true}
                value={bankAddress?.address2 ? bankAddress?.address2 : ""}
                onChange={(e) => {
                  bankAddress[e.target.name] = e.target.value;
                  updateState({
                    ...state,
                    bankAddress,
                  });
                }}
              />

              <p className="label">City or Town</p>
              <input
                type="text"
                name="city"
                placeholder="City or Town"
                disabled={!iscompletedForm ? false : true}
                value={bankAddress?.city ? bankAddress?.city : ""}
                className={
                  !bankAddress?.city
                    ? validationError?.data
                      ? "form-control errorInput"
                      : "form-control"
                    : "form-control"
                }
                onChange={(e) => {
                  bankAddress[e.target.name] = e.target.value;
                  updateState({
                    ...state,
                    bankAddress,
                  });
                }}
              />
              <div className="error">
                {!bankAddress?.city
                  ? validationError?.data
                    ? warningError
                    : ""
                  : ""}
                {!bankAddress?.city
                  ? validationError?.data
                    ? "Please enter your city or town"
                    : ""
                  : ""}
              </div>

              <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <p className="label">County (Optional)</p>
                  <input
                    type="text"
                    name="country"
                    className="form-control"
                    placeholder="County (Optional)"
                    disabled={!iscompletedForm ? false : true}
                    value={bankAddress?.country ? bankAddress?.country : ""}
                    onChange={(e) => {
                      bankAddress[e.target.name] = e.target.value;
                      updateState({
                        ...state,
                        bankAddress,
                      });
                    }}
                  />
                </Col>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <p className="label">Postcode</p>
                  <input
                    type="text"
                    name="postCode"
                    placeholder="Postcode"
                    disabled={!iscompletedForm ? false : true}
                    value={bankAddress?.postCode ? bankAddress?.postCode : ""}
                    className={
                      !bankAddress?.postCode
                        ? validationError?.data
                          ? "form-control errorInput"
                          : "form-control"
                        : "form-control"
                    }
                    onChange={(e) => {
                      getPostCode(e.target.value);
                      bankAddress[e.target.name] = e.target.value;
                      updateState({
                        bankAddress,
                        ...state,
                      });
                    }}
                  />
                  <div className="error">
                    {!bankAddress?.postCode
                      ? validationError?.data
                        ? warningError
                        : ""
                      : ""}
                    {!bankAddress?.postCode
                      ? validationError?.data
                        ? "Please enter a valid post code"
                        : ""
                      : ""}
                  </div>
                  <div
                    style={{
                      display:
                        postcodeLoader || searchmode || postCodeArray?.length
                          ? "flex"
                          : "none",
                    }}
                    className={
                      postcodeLoader || searchmode || postCodeArray?.length
                        ? "postcode-list-div"
                        : ""
                    }
                  >
                    {!postcodeLoader ? (
                      searchmode && postCodeArray?.length ? (
                        postCodeArray.map((post, index) => (
                          <p
                            key={index}
                            style={{ cursor: "pointer", margin: "0px" }}
                            onClick={() => {
                              bankAddress.postCode = post;
                              updateState({
                                ...state,
                                bankAddress,
                                postCodeArray: [],
                                postcodeLoader: false,
                                searchmode: false,
                              });
                            }}
                          >
                            <div className="flex-start-center post-value">
                              <Image
                                className="img"
                                src={require("./../../assets/icons/gps.png")}
                              />
                              <span>{post}</span>
                            </div>
                          </p>
                        ))
                      ) : (
                        "no post code"
                      )
                    ) : (
                      <div className="flex-center-center p-3">
                        <Spinner
                          animation="border"
                          style={{ width: "25px", height: "25px" }}
                        />
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              <div
                style={{
                  borderBottom: "1px solid #00000033",
                  marginTop: "37.7px",
                  marginBottom: "40.3px",
                }}
              />

              <p className="step-title">Student and parent contributions</p>
              <p className="step-subtitle">
                To show appreciation for quality tutoring, parents and tutors
                can send optional financial contributions to tutors during
                lessons or after completing lessons. Tutors can opt to
                automatically allow or decline future contributions.
              </p>

              <div className="Switch">
                <p className="step-title normal">Allow contributions</p>
                <label className="switch">
                  <input
                    type="checkbox"
                    defaultChecked={allowContributions}
                    onClick={() =>
                      updateState({
                        ...state,
                        allowContributions: !allowContributions,
                      })
                    }
                  />
                  <span className="slider round"></span>
                </label>
              </div>

              <div
                style={{
                  borderBottom: "1px solid #00000033",
                  marginTop: "33.5px",
                  marginBottom: "37.5px",
                }}
              />

              <p className="step-subtitle step1">
                100% of all contributions will be deposited into your payout
                account, unless you have an account balance. Your payout is
                subject to the{" "}
                <span style={{ color: "#2cb46d" }}>
                  Payment Terms of Service
                </span>
                . Please note that your contribution may not be tax-deductible
                or eligible for tax credits. To learn more about guest
                contributions, visit the{" "}
                <span style={{ color: "#2cb46d" }}>Help Centre</span>.
              </p>
            </Col>
          </Row>
          <Nextsteps step={8} {...props} submitStepInRedux={submitStep8Info} />
        </div>
      </Col>
    </Row>
  );
};
